export default "__VITE_ASSET__21e5c913__"